export default {
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  code: {
    value: '',
    maxlength: '10',
    required: true,
    state: null
  },
  acronym: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/bank/bank-form.js